import { ReactElement } from 'react';
import { S_AnnotationStatus } from '../../../annotations/annotationStatus/S_AnnotationStatus';
import { IGroundTruth, IRectanglePrediction } from '../../jobPredictions.model';

interface IProps {
  predictedRectangles: IRectanglePrediction[] | null;
  threshold: number;
  groundTruth: IGroundTruth | null | undefined;
}

export const LocateObjects = ({ predictedRectangles, threshold, groundTruth }: IProps): ReactElement => {
  if (!predictedRectangles) {
    return <></>;
  }

  return (
    <>
      {predictedRectangles.map((predictedRectangle) => {
        return (
          <div
            key={predictedRectangle.classId}
            className='attributes'
          >
            <span className='attribute'>
              {predictedRectangle.className}:{' '}
              <S_AnnotationStatus
                text={`${predictedRectangle.rectangles.filter((rectangle) => rectangle.score >= threshold).length.toString()}${groundTruth?.predictionCounts?.[predictedRectangle.className] ? `/${groundTruth.predictionCounts[predictedRectangle.className]}` : ''}`}
              />
            </span>
          </div>
        );
      })}
    </>
  );
};
